/* eslint-disable jsx-a11y/anchor-is-valid */
import secondaryComponents from "../../../../components/secondaryComponents";
import { motion } from "framer-motion";
import useExpenses from "./useExpenses";
import primaryComponents from "../../../../components/primaryComponents";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import { PlusIcon } from "../../../../assets/svgIcons";
import { RoutedModal } from "../../../../components/common";
import { ExpenseCreationType } from "../../../../components/secondaryComponents/Expenses";

const expenseTabs = [
  { name: "Expense", isRecurring: false },
  { name: "Recurring", isRecurring: true },
];

const Expenses = () => {
  const {
    isFetchingExpenses,
    expenses,
    metaDetails,
    search,
    storeList,
    storeHasMultipleCurrency,
    expenseCategories,
    isCreateExpense,
    isExpenseOption,
    expenseDepartments,
    isRecurringTab,
    filterByKey,
    setIsExpenseOption,
    filterByStoreId,
    filterByCategoryId,
    filterByRecurring,
    setIsCreateExpense,
    handleFetchExpenses,
    gotoPage,
    searchExpenses,
  } = useExpenses();

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Expenses"
      description="View all expenses"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={`${globalStyles?.pageColumnGaps}`}
        >
          <div>
            <h4 className="mb-0">Expenses</h4>
            <p>Track and manage all your expenses in one place</p>
          </div>

          <div className={globalStyles.rowNavigations}>
            {expenseTabs?.map((item, index) => (
              <a
                key={index}
                className={`${globalStyles.rowNavigations__item} ${
                  isRecurringTab === item.isRecurring ? globalStyles.active : ""
                }`}
                onClick={() => filterByRecurring(item.isRecurring)}
              >
                {item.name}
              </a>
            ))}
          </div>

          <div className={globalStyles.pageHeaders}>
            <p>{metaDetails?.total} expenses</p>

            <secondaryComponents.NavigateWithPermission
              permissionParentKey={"Expense"}
              permissionChildKey="can_create_expense"
            >
              <primaryComponents.Button
                classNames="btn btn--primary ml-auto"
                onClick={() => setIsExpenseOption(true)}
              >
                <PlusIcon className="mr-1" /> Create Expenses
              </primaryComponents.Button>
            </secondaryComponents.NavigateWithPermission>
          </div>

          <div className={globalStyles.tableWrapper}>
            <div className={`${globalStyles.tableHeader} align-items-end`}>
              <primaryComponents.SearchField
                classNames={globalStyles.searchField}
                placeholder="Search for expenses"
                trigger={(value) => searchExpenses(value)}
                value={search.get("query") !== null ? search.get("query") : ""}
                triggerOnInput={true}
                showsearchBtn={true}
              />

              {/* categories */}
              <div className="ml-auto" style={{ width: "170px" }}>
                <primaryComponents.SelectField
                  options={[
                    {
                      name: "All Categories",
                      id: null,
                    },
                    ...expenseCategories,
                  ]}
                  idKey="id"
                  nameKey="name"
                  onChange={(value) => {
                    filterByCategoryId(value);
                  }}
                  label={"Filter Category"}
                  value={
                    expenseCategories?.find(
                      (cat) => `${cat?.id}` === `${search.get("category_id")}`,
                    )?.name || "All Categories"
                  }
                  floatError={false}
                  classNames="category-select"
                />
              </div>
              <div style={{ width: "170px" }}>
                <primaryComponents.SelectField
                  options={[
                    {
                      name: "All Department",
                      id: null,
                    },
                    ...expenseDepartments,
                  ]}
                  label={"Filter Department"}
                  idKey="id"
                  nameKey="name"
                  onChange={(value) => {
                    filterByKey("departments_id", value);
                  }}
                  value={
                    expenseDepartments?.find(
                      (department) =>
                        `${department?.id}` === search.get("departments_id"),
                    )?.name || "All Department"
                  }
                  floatError={false}
                  classNames="store-select"
                />
              </div>
              <div style={{ width: "170px" }}>
                <primaryComponents.SelectField
                  options={
                    storeHasMultipleCurrency
                      ? [...storeList]
                      : [
                          {
                            name: "All stores",
                            id: null,
                          },
                          ...storeList,
                        ]
                  }
                  label={"Filter Store"}
                  idKey="id"
                  nameKey="name"
                  onChange={(value) => {
                    filterByStoreId(value);
                  }}
                  value={
                    storeList?.find(
                      (storeItem) =>
                        `${storeItem?.id}` === search.get("store_id"),
                    )?.name || "All stores"
                  }
                  floatError={false}
                  classNames="store-select"
                />
              </div>
            </div>

            <secondaryComponents.LoaderHelper
              isLoading={isFetchingExpenses}
              classNames="mt-5"
            >
              <secondaryComponents.ExpensesTable
                metaDetails={metaDetails}
                expenses={expenses}
                isRecurringTab={isRecurringTab}
                handleFetchExpenses={handleFetchExpenses}
                gotoPage={gotoPage}
              />
            </secondaryComponents.LoaderHelper>
          </div>

          <RoutedModal
            width={1000}
            isActive={isCreateExpense}
            closeModal={() => setIsCreateExpense(false)}
            headerTitle="Create Expense"
            headerDescription="Record and initiate disbursements."
          >
            <secondaryComponents.CreateExpense
              closeWidget={() => setIsCreateExpense(false)}
            />
          </RoutedModal>

          <RoutedModal
            isActive={isExpenseOption}
            width={600}
            closeModal={() => setIsExpenseOption(false)}
            headerTitle="Create Expense"
            style={{ height: "auto" }}
          >
            <ExpenseCreationType
              navigateToSingleExpense={() => {
                setIsCreateExpense(true);
                setIsExpenseOption(false);
              }}
            />
          </RoutedModal>
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};

export default Expenses;
